import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Platform,
  View,
  ScrollView,
  KeyboardAvoidingView,
  Text,
  TouchableOpacity,
  ActivityIndicator,
} from 'react-native';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { FlatGrid } from 'react-native-super-grid';

import AORTypes from '../../types';
import { AppSyncClientAudit } from '../../backends/AppSyncClientAudit';
import GetPendingApps from '../../q/audit/GetPendingApps';
import AppBadge from '../../components/apps/AppBadge';
import styles from '../../styles';
import App from '../../modules/data/App';

class PendingApps extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PendingApps';
  }

  render() {
    const {
      apps,
      history,
      userData,
    } = this.props;

    if (!userData) {
      return (
        <View
          style={{
            backgroundColor: 'white',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    return (
      <View style={styles.view.headed}>
        <View style={styles.view.form}>
          <KeyboardAvoidingView
            style={[styles.form.container, {
              backgroundColor: 'white',
            }]}
            behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          >
            <View style={{
              flex: 1,
              flexDirection: 'column',
              width: '100%',
              alignItems: 'center',
            }}
            >
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 60,
                }}
              >
                {/* Choose the language here */}
                {/* <Text></Text> */}
              </View>
              {apps.length < 1 ? (
                <View
                  style={{
                    flex: 1,
                    width: '100%',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Text>
                    No apps queued for review.
                  </Text>
                </View>
              ) : (
                <ScrollView
                  style={{
                    flex: 1,
                    width: '100%',
                  }}
                >
                  <FlatGrid
                    itemDimension={310} // The lower value makes Safari wrap the price if both rent and buy are two digits prior to the decimal point
                    data={apps}
                    renderItem={
                      ({ item }) => {
                        const app = App.createFromData(item);
                        return (
                          <>
                            <TouchableOpacity onPress={() => (
                              history.push(`/ai-agent-review/${app.data.uuid}`)
                            )}
                            >
                              <AppBadge data={app.data} />
                            </TouchableOpacity>
                            <Text>{`Language: ${app.data.lang}`}</Text>
                          </>
                        );
                      }
                    }
                  />
                </ScrollView>
              )}
            </View>
          </KeyboardAvoidingView>
        </View>
      </View>
    );
  }
}

PendingApps.defaultProps = {
  apps: [],
  userData: null,
};

PendingApps.propTypes = {
  apps: PropTypes.arrayOf(AORTypes.App),
  history: ReactRouterPropTypes.history.isRequired,
  userData: AORTypes.User,
};

export default compose(
  graphql(GetPendingApps, {
    props: (props) => {
      console.log('graphql returned: GetPendingApps: ');
      console.log(props.data);

      if (!props.data.getPendingApps) {
        return {
          apps: [],
        };
      }
      return {
        apps: props.data.getPendingApps.items,
      };
    },
    options: (props) => ({
      variables: {
        lang: '*',
      },
      client: AppSyncClientAudit(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientAudit(props.user),
  })
)(PendingApps);
